import * as types from './mutation-types'

export const ToogleMenu = ({ commit }, payload) => {
    return commit(types.SHOW_SIDEBAR, payload)
}

